// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FilingJobStatus = {
    Pending: 'PENDING',
    InProgress: 'IN_PROGRESS',
    Succeeded: 'SUCCEEDED',
    Failed: 'FAILED'
} as const;
export type FilingJobStatus = typeof FilingJobStatus[keyof typeof FilingJobStatus];


export function instanceOfFilingJobStatus(value: any): boolean {
    for (const key in FilingJobStatus) {
        if (Object.prototype.hasOwnProperty.call(FilingJobStatus, key)) {
            if (FilingJobStatus[key as keyof typeof FilingJobStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FilingJobStatusFromJSON(json: any): FilingJobStatus {
    return FilingJobStatusFromJSONTyped(json, false);
}

export function FilingJobStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilingJobStatus {
    return json as FilingJobStatus;
}

export function FilingJobStatusToJSON(value?: FilingJobStatus | null): any {
    return value as any;
}

export function FilingJobStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): FilingJobStatus {
    return value as FilingJobStatus;
}
